import React from 'react';
import ReactDOM from 'react-dom/client';
import './assets/main.css';
import './assets/index.css';
import { BrowserRouter } from 'react-router-dom';
import App from './app/App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <BrowserRouter>
    <App />
  </BrowserRouter>,
);
